import i18next from 'i18next';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledSelect } from 'components/shared/ControlledFields';

const tenantOptions = [
  { value: 'dzz', label: i18next.t('cronJobs.form.dzz') },
  { value: '*', label: i18next.t('cronJobs.form.allTenants') }
];

const minusDaysOptions = [
  { value: '0', label: i18next.t('today') },
  { value: '1', label: i18next.t('yesterday') },
  { value: '2', label: i18next.t('dayBeforeYesterday') }
];

const plusDaysOptions = [
  { value: '0', label: i18next.t('today') },
  { value: '1', label: i18next.t('tomorrow') },
  { value: '2', label: i18next.t('dayAfterTomorrow') },
  { value: '3', label: i18next.t('_4Days') },
  { value: '4', label: i18next.t('_5Days') },
  { value: '5', label: i18next.t('_6Days') },
  { value: '6', label: i18next.t('oneWeek') },
  { value: '13', label: i18next.t('twoWeeks') },
  { value: '20', label: i18next.t('threeWeeks') },
  { value: '27', label: i18next.t('fourWeeks') },
  { value: '55', label: i18next.t('eightWeeks') }
];

export const SyncEmployeeRoutesSection = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <ControlledSelect
        variant="outlined"
        label={t('cronJobs.grid.tenant')}
        control={control}
        name="config.tenantId"
        options={tenantOptions}
      />
      <ControlledSelect
        variant="outlined"
        label={t('Start sync')}
        control={control}
        name="config.minusDays"
        options={minusDaysOptions}
      />
      <ControlledSelect
        variant="outlined"
        label={t('Einde sync')}
        control={control}
        name="config.plusDays"
        options={plusDaysOptions}
      />
    </div>
  );
};
